import {h, Fragment} from "preact";
import { Page } from "../common/Page";
import * as React from "preact/compat";
import {gridSize, fontColour, smallScreenThreshold} from "../style-variables";
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faUserFriends, faUserGraduate, faFastForward, faCompass } from '@fortawesome/free-solid-svg-icons'

// @ts-ignore
import avatar from "url:./avatar.jpg";
import {useEffect, useRef, useState} from "preact/hooks";
import {ModalDialog} from "../common/ModalDialog";

const Avatar = styled.div`
  margin: 0 auto;
  height: ${gridSize * 3}px;
  width: ${gridSize * 3}px;
  background: url("${avatar}");
  background-size: cover;
  border-radius: ${gridSize * 4}px;
  border: 2px solid #fff;
`;

const MePage = styled(Page)`
    top: ${gridSize * 2}px;
    bottom: 0;
    overflow: hidden;
    @media screen and (max-width: 800px) {
        overflow: scroll;
    }
`;

const MeScrollContainer = styled.div`
    transform: translateY(${props => props.pageScroll || 0}px);
    transition: transform 0.6s ease-in-out;
    position: relative;
    z-index: 1;
    @media screen and (max-width: ${smallScreenThreshold}) { 
        transform: none; 
    }
`

const MeSection = styled.div`
    opacity: ${props => props.isCurrentSection ? 1 : 0.1};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: opacity 0.6s ease-in-out;
    height: 100%;
    @media screen and (max-width: ${smallScreenThreshold}) { 
        opacity: 1;
        height: auto;
    }
`;

const MeSectionProgressButton = styled.button`
    margin: 0 auto;
    height: ${gridSize * 2}px;
    width: 100%;
    cursor: pointer;
    background: none;
    border: none;
    font-size: ${gridSize};
    color: ${fontColour};
    opacity: 0.2;
    transition: opacity 0.3s;
    z-index: 0;
    &:hover {
        opacity: 1;
    }
    @media screen and (max-width: ${smallScreenThreshold}) { 
        display: none;
    }
`
const SectionNav = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: ${gridSize * 2}px 0;
    position: fixed;
    bottom: 0;
    z-index: 9999;
    @media screen and (max-width: ${smallScreenThreshold}) { 
        display: none;  
    }
`
const SectionNavItem = styled.li`
    opacity: ${props => props.isCurrentSection ? 1 : 0.2};
    transition: opacity 0.6s ease-in-out;
    width: ${gridSize}px;
    height: ${gridSize / 2}px;
    background: ${fontColour};
    border-top: 1px solid ${fontColour};
    cursor: pointer;
    margin: 0 ${gridSize / 3}px;
    
    &:hover {
        opacity: 1;
    }
`

const WhatDoesThisMeanButton = styled.button`
    border: none;
    background: none;
    color: ${fontColour};
    font-size: ${gridSize / 2}px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    padding: ${gridSize};
    opacity: 0.2;
    transition: opacity 0.3s;
    &:hover {
        opacity: 1;
    }
`
export const Me = () => {
    const sections = [
        {
            section: <>
                        <Avatar />
                        <p>
                            I'm a full stack software engineer based in <strong>Sydney</strong> since <strong>2010</strong>.
                            Throughout the years I have helped to scale engineering teams to build great product features. I'm
                            first and foremost a <strong>builder</strong> who believes that a team is greater than the sum total of
                            its parts. On this site you will read more about me, the things I believe in and the way these impact
                            the way that I work.
                        </p>
                    </>
        },
        {
            section: <>
                        <h1> My Principles </h1>
                        <p>
                            These principles govern the way I work, if you are ever on a team with me you'll see these
                            principles manifest in almost everything I do.
                        </p>
                    </>,
        },
        {
            section: <>
                        <h2><FontAwesomeIcon icon={faUserFriends}/> Culture </h2>
                        <p>
                            I believe a team that trusts each other is the best kind of team and I believe that teams that works
                            together well can accomplish anything. Team culture is the most important driver of trust and so when
                            you work with me you'll find that I am an advocate for a strong team culture and I believe that
                            identity both at the team and individual level are essential to this culture.
                        </p>
                    </>,
            detailsHeader: <><h3> <FontAwesomeIcon icon={faUserFriends}/> Culture </h3></>,
            details: <>
                        <p>
                            I believe that team identity and culture is an amalgamation of each individual's identity. It is therefore important that everyone on the team has an understanding of the identity of everyone else on the team.
                            You'll see me do the following things in order to establish that identity and foster a team culture:
                            <ul>
                                <li>Ask peers about themselves, their hobbies and personal lives. </li>
                                <li>Ask peers about their professional and personal motivations. </li>
                                <li>Express my opinions and the reasons for them openly. </li>
                                <li>Remind myself and others that they am allowed to have opinions though they may differ from those of others. </li>
                            </ul>
                        </p>
                    </>
        },
        {
            section: <>
                <h2><FontAwesomeIcon icon={faUserGraduate}/> Failure </h2>
                <p>
                    Failure is a human's most powerful learning tool. I see every failure as an opportunity to grow and
                    within a team I will endorse an
                    environment where failure is not only tolerated but safe. I believe that when individuals and teams
                    are not afraid of failure they will
                    push themselves to succeed. The two essential ingredients to this are courage against the fear of
                    failure and the emphasis of lessons
                    learnt over fault.
                </p>
            </>,
            detailsHeader: <><h3> <FontAwesomeIcon icon={faUserGraduate}/> Failure </h3></>,
            details: <>
                <p>
                    Constantly reviewing past failures is paramount to learning from them. So too is understanding that
                    failure is often not a reflection of capability but rather a reflection of experience; moving on from failure is the first step of learning from it.
                    You'll see me:
                    <ul>
                        <li>Constantly identify the failures in the things I do in order to put a name/face to them</li>
                        <li>Remind myself and others that these failures are new experiences gained</li>
                        <li>Remind myself and others that doing nothing is worse than failing in most cases</li>
                    </ul>
                </p>
            </>
        },
        {
            section: <>
                <h2><FontAwesomeIcon icon={faFastForward}/> Pragmatism </h2>
                <p>
                    Perfect is the enemy of good. When faced with many technical options and a stalemate decision most
                    often simply picking one and running
                    with it is the best course of action. Most decisions in software are reversible and those that are
                    not can be progressed by exploration
                    and spiking. I believe the cornerstones of pragmatism to be valuing action over discussion and
                    ensuring options considered are relevant
                    to the problem at hand.
                </p>
            </>,
            detailsHeader: <><h3> <FontAwesomeIcon icon={faFastForward}/> Pragmatism </h3></>,
            details: <>
                <p>
                    Gathering just enough relevant data (and not neccessarily ALL the data) is important to making timely decisions, as is pulling in just the right cooks. That means I will:
                    <ul>
                        <li>Time box all decisions that need to be made with a deadline </li>
                        <li>Identify up front if a decision is a one way or two way door </li>
                        <li>Gather input explicitly 1:1 rather than by broadcast </li>
                        <li>Favour actions and exploration over more discussion </li>
                        <li>Identify the main characteristics of the problem at hand </li>
                        <li>Describe the options in terms of the characteristics of the problem at hand </li>
                        <li>Discard pros or cons that cannot be expressed in terms of the problem at hand as they are likely sources from bias rather than relevance to the problem. </li>
                    </ul>
                </p>
            </>
        },
        {
            section: <>
                        <h2><FontAwesomeIcon icon={faCompass}/> Direction </h2>
                        <p>
                            In any system that you build there is always a tomorrow where you are not the one working on it.
                            This is true in small systems and true in
                            large complex systems. I will always seek to establish a direction such that if tomorrow I am
                            absent, the next person can continue in the
                            same direction that the system was heading in or steer it in a different direction if need be. This
                            principle can be applied to high level
                            system design as well as lower level coding practices. The emphasis here is on clarity of direction
                            and considering a future without myself.
                        </p>
                    </>,
            detailsHeader: <> <h3> <FontAwesomeIcon icon={faCompass}/> Direction </h3> </>,
            details: <>
                <p>
                    The key to maintaining momentum in a direction is shared understanding at the right time. This means that I will:
                    <ul>
                        <li>Identify my areas of expertise and understand the target state of each of those areas</li>
                        <li>Bring the relevant information about target states when making decisions surrounding a system (or bring in the people that know those target states) </li>
                        <li>Document these direction in discoverable / useful ways</li>
                        <li>Update this direction regularly so that it does not become stale </li>
                        <li>Pass on this direction if I am to move on. </li>
                    </ul>
                </p>
            </>
        }

    ]

    // States
    const [scrollHeight, setScrollHeight] = useState(0);
    const [currentSection, setCurrentSection] = useState(0);
    const [dialogStates, setDialogStates] = useState(sections.map(() => false));
    const mePageRef = useRef(null);

    const nextSection = () => {
        if(currentSection < sections.length - 1) {
            setCurrentSection(currentSection + 1);
        }
    }

    const previousSection = () => {
        if(currentSection > 0) {
            setCurrentSection(currentSection - 1);
        }
    }

    const NextButton = () => <MeSectionProgressButton onClick={nextSection}><FontAwesomeIcon icon={faAngleDown} /></MeSectionProgressButton>
    const PreviousButton = () => <MeSectionProgressButton onClick={previousSection}><FontAwesomeIcon icon={faAngleUp} /></MeSectionProgressButton>

    const isADialogOpen = () => dialogStates.indexOf(true) > -1

    const isCurrentSection = (thisSection) => currentSection === thisSection;

    const sectionNav = sections.map((section, index) => <SectionNavItem isCurrentSection={isCurrentSection(index)} onClick={ () => setCurrentSection(index)}/>)

    const openDialog = (dialogIndex: number) => () => {
        dialogStates[dialogIndex] = true;
        setDialogStates(dialogStates.slice());
    }

    const closeDialog = (dialogIndex: number) => () => {
        dialogStates[dialogIndex] = false;
        setDialogStates(dialogStates.slice());
    }

    //Side Effects

    useEffect(() => {
        setScrollHeight(-currentSection * mePageRef.current.offsetHeight);
    });

    useEffect(() => {
        const progressThroughScroll = (event) => {
                if(event.deltaY > 0 && !isADialogOpen()) {
                    nextSection();
                } else if(event.deltaY < 0 && !isADialogOpen()) {
                    previousSection();
                }
        }
        let touchStartY = 0;

        document.addEventListener("wheel", progressThroughScroll);
        return () => {
            document.removeEventListener("wheel", progressThroughScroll);
        }
    })
    return (
        <MePage ref={mePageRef} >
            <MeScrollContainer pageScroll={scrollHeight}>
                {sections.map((section, index) => {
                    return (
                    <MeSection key={index} isCurrentSection={isCurrentSection(index)}>
                            {index > 0 && <PreviousButton />}
                            {section.section}
                            {section.details && (
                                <>
                                    <WhatDoesThisMeanButton onClick={openDialog(index)}> What does this mean... </WhatDoesThisMeanButton>
                                    <ModalDialog header={section.detailsHeader} isOpen={dialogStates[index]} onBlanketClick={closeDialog(index)} onCloseClick={closeDialog(index)}> {section.details} </ModalDialog>
                                </>
                            )}
                            {index < sections.length-1 && <NextButton />}
                        </MeSection>
                    )
                })}
            </MeScrollContainer>
            <SectionNav>
                {sectionNav}
            </SectionNav>
        </MePage>
    );
};
